/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import { useSelectionContext } from './SelectionProvider'
import { Alert, AlertProps, Button, Group, Text } from '@mantine/core'

export type SelectionAlertProps = AlertProps

function SelectionAlert (props: SelectionAlertProps) {
  const { children, ...others } = props
  const selection = useSelectionContext()
  const intl = useIntl()

  if (selection.empty) {
    return null
  }

  return (
    <Alert {...others}>
      <Group gap="xs">
        <Text inherit fw="bold">
          {intl.formatMessage({
            id: 'n_items_selected',
            defaultMessage: '{count, plural, one {# élément sélectionné} other {# éléments sélectionnés}}'
          }, {
            count: selection.items.length
          })}
        </Text>
        <Button
          onClick={selection.clear}
          variant="subtle"
        >
          {intl.formatMessage({
            id: 'unselect_all_items',
            defaultMessage: 'Tout désélectionner'
          })}
        </Button>

        {children}
      </Group>
    </Alert>
  )
}

export default SelectionAlert
